import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { dashboardsSelector } from "./dashboardsSelector";

export const sortedDashboardsSelector = createDraftSafeSelector(
  [dashboardsSelector],
  (resourceExplorerViews) => {
    return [...(resourceExplorerViews ?? [])].sort((a, b) => {
      return a.created_at.localeCompare(b.created_at);
    });
  },
);
